import { render } from "./Sidebar.vue?vue&type=template&id=7d622f5c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=7d622f5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d622f5c"],['__file',"src/components/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d622f5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d622f5c', __exports__)) {
    api.reload('7d622f5c', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=7d622f5c&scoped=true", () => {
    api.rerender('7d622f5c', render)
  })

}


export default __exports__